// Station name normalization utility
// Handles both old format ("G1") and new format ("Station G1")

export const normalizeStationName = (stationName, stationId) => {
  if (!stationName && !stationId) return '';
  
  // Wenn bereits das korrekte Format vorhanden ist
  if (stationName && stationName.startsWith('Station ')) {
    return stationName;
  }
  
  // Wenn nur der kurze Name vorhanden ist (z.B. "G1")
  if (stationName && ['G1', 'G5', 'G8', 'G10'].includes(stationName)) {
    return `Station ${stationName}`;
  }
  
  // Fallback: Generiere aus station_id
  if (stationId) {
    const stationMap = {
      1: 'Station G1',
      5: 'Station G5',
      8: 'Station G8',
      10: 'Station G10'
    };
    return stationMap[parseInt(stationId)] || `Station ${stationId}`;
  }
  
  return stationName || '';
};

export const getStationNameSafe = (stationId, fallbackName = '') => {
  const stations = {
    1: 'G1',
    5: 'G5', 
    8: 'G8',
    10: 'G10'
  };
  
  const normalizedId = parseInt(stationId) || parseInt(parseFloat(stationId));
  return stations[normalizedId] || fallbackName || `${stationId}`;
};